import { css } from '@emotion/react'
import styled from '@emotion/styled'

import { spacer, SpacerDefs } from '@pharmac/ui'
import { HTMLAttributes, PropsWithChildren } from 'react'
import { joinClasses } from './extranet-table/joinClasses'

type FlexboxDefs = {
  justifyStart?: boolean
  justifyEnd?: boolean
  justifyCenter?: boolean
  spaceEvenly?: boolean
  spaceBetween?: boolean
  spaceAround?: boolean
  alignStart?: boolean
  alignEnd?: boolean
  alignCenter?: boolean
  flexColumn?: boolean
  flexColumnReverse?: boolean
  flexRow?: boolean
  flexRowReverse?: boolean
  flexWrap?: boolean
}

const flexProps = (props: FlexboxDefs) => {
  const flexDirection = (() => {
    const { flexRow, flexRowReverse, flexColumn, flexColumnReverse } = props
    if (!!flexRow || !!flexRowReverse || !flexColumn || !flexColumnReverse) {
      if (flexRow) return 'row'
      if (flexRowReverse) return 'row-reverse'
      if (flexColumn) return 'column'
      if (flexColumnReverse) return 'column-reverse'
    }

    return 'row'
  })()

  return css`
    flex-wrap: ${props.flexWrap ? 'wrap' : 'no-wrap'};
    flex-direction: ${flexDirection};
  `
}

const flexAlign = (props: FlexboxDefs) => {
  let alignItems = 'flex-start'

  if (props.alignCenter) alignItems = 'center'
  if (props.alignEnd) alignItems = 'flex-end'

  return css`
    align-items: ${alignItems};
  `
}

const flexJustify = (props: FlexboxDefs) => {
  let justifyContent = 'flex-start'

  if (props.justifyEnd) justifyContent = 'flex-end'
  if (props.justifyCenter) justifyContent = 'center'
  if (props.spaceAround) justifyContent = 'space-around'
  if (props.spaceBetween) justifyContent = 'space-between'
  if (props.spaceEvenly) justifyContent = 'space-evenly'

  return css`
    justify-content: ${justifyContent};
  `
}

export const flex = (props: FlexboxDefs) => {
  return css`
    ${flexAlign(props)}
    ${flexJustify(props)}
    ${flexProps(props)}
  `
}

type ExtranetContainerRootProps = {
  full?: boolean
  half?: boolean
  third?: boolean
  fourth?: boolean
  fifth?: boolean
  sixth?: boolean
  twoThirds?: boolean
} & FlexboxDefs &
  SpacerDefs

const getWidth = (props: ExtranetContainerRootProps) => {
  const { full, half, third, twoThirds, fourth, fifth, sixth } = props

  const width =
    (full && 100) ||
    (half && 50) ||
    (third && 33.333) ||
    (twoThirds && 66.666) ||
    (fourth && 25) ||
    (fifth && 20) ||
    (sixth && 16.666) ||
    undefined

  return !!width
    ? css`
        width: ${width}%;
      `
    : ''
}

export const ExtranetContainerRoot = styled.div<ExtranetContainerRootProps>`
  display: flex;

  ${getWidth}

  height: auto;

  ${(p) => spacer(p)};
  ${(p) => flex(p)}
`

type ExtranetContainerProps = PropsWithChildren &
  HTMLAttributes<HTMLDivElement> &
  ExtranetContainerRootProps

export const ExtranetContainer = (props: ExtranetContainerProps) => {
  return (
    <ExtranetContainerRoot
      className={joinClasses('encontainer', props.className)}
      {...props}
    >
      {props.children}
    </ExtranetContainerRoot>
  )
}
